import { render, staticRenderFns } from "./roleAuthReport.vue?vue&type=template&id=553754d2&scoped=true&"
import script from "./roleAuthReport.vue?vue&type=script&lang=js&"
export * from "./roleAuthReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553754d2",
  null
  
)

export default component.exports